'use client';

import {
  BarChart as RechartsBarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

export interface BarChartDataPoint {
  name: string;
  value: number;
  [key: string]: string | number;
}

interface BarChartProps {
  data: BarChartDataPoint[];
  title?: string;
  height?: number;
  xKey?: string;
  yKey?: string;
  color?: string;
  showGrid?: boolean;
  showLegend?: boolean;
  horizontal?: boolean;
}

export function BarChart({
  data,
  title,
  height = 300,
  xKey = 'name',
  yKey = 'value',
  color = 'hsl(var(--primary))',
  showGrid = true,
  showLegend = false,
  horizontal = false,
}: BarChartProps) {
  return (
    <div>
      {title && (
        <h3 className="text-lg font-semibold mb-4">{title}</h3>
      )}
      <div className="rounded-lg border bg-card p-4">
        <ResponsiveContainer width="100%" height={height}>
          <RechartsBarChart data={data} layout={horizontal ? 'vertical' : 'horizontal'}>
            {showGrid && (
              <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
            )}
            <XAxis
              dataKey={horizontal ? yKey : xKey}
              type={horizontal ? 'number' : 'category'}
              stroke="hsl(var(--muted-foreground))"
              fontSize={12}
            />
            <YAxis
              dataKey={horizontal ? xKey : undefined}
              type={horizontal ? 'category' : 'number'}
              stroke="hsl(var(--muted-foreground))"
              fontSize={12}
            />
            <Tooltip
              contentStyle={{
                backgroundColor: 'hsl(var(--card))',
                border: '1px solid hsl(var(--border))',
                borderRadius: '8px',
                color: 'hsl(var(--foreground))',
              }}
            />
            {showLegend && <Legend />}
            <Bar dataKey={yKey} fill={color} radius={[4, 4, 0, 0]} />
          </RechartsBarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
